/*jshint esversion: 6 */
export function Common__$(selector, $context) {
    return ($context === undefined ? document : $context).querySelector(selector);
}

export function Common__$$(selector, $context) {
    return ($context === undefined ? document : $context).querySelectorAll(selector);
}

export function Common__domOn($elem, type, listener) {
    $elem.addEventListener(type, listener);
}

export function Common__domHasClass($elem, className) {
    if (Array.isArray(className)) {
        return className.some(function(c) {
            return $elem.classList.contains(c);
        });
    }

    return $elem.classList.contains(className);
}

export function Common__domAddClass($elem, className) {
    if (!$elem) {
        return;
    }

    $elem.classList.add(className);
}

export function Common__domRemoveClass($elem, className) {
    if (!$elem) {
        return;
    }

    $elem.classList.remove(className);
}


export function Common__domShow($elem) {
    if ($elem.style.display == 'none') {
        $elem.style.display = '';
        return true;
    }

    return false;
}

export function Common__domTrigger($elem, type, data, extraProps) {
    var event = document.createEvent('HTMLEvents');

    event.initEvent(type, true, true);
    event.data = data;
    Common__objectExtend(event, extraProps);
    $elem.dispatchEvent(event);

    return event;
}

export function Common__arrayRemove(arr, item) {
    var index = arr.indexOf(item);

    if (index > -1) {
        arr.splice(index, 1);
    }
}

export function Common__domClosest($elem, selector, $context) {
    var callback = selector instanceof Function ? selector : function($elem) {
        return Common__domIs($elem, selector);
    };

    for ( ; $elem && $elem !== $context; $elem = $elem.parentElement) {
        if (callback($elem)) {
            return $elem;
        }
    }

    return null;
}

export function Common__domIs($elem, selector) {
    var elementPrototype = Element.prototype;

    return (elementPrototype.matches || elementPrototype.webkitMatchesSelector || elementPrototype.msMatchesSelector).call($elem, selector);
}

export function Common__domHide($elem) {
    if ($elem.style.display != 'none') {
        $elem.style.display = 'none';
        return true;
    }

    return false;
}

export function Common__debounce(func, wait) {
    var timer;

    return function() {
        var context = this,
            args = arguments;

        clearTimeout(timer);

        timer = setTimeout(function() {
            func.apply(context, args);
        }, wait);
    };
}

export function Common__throttle(func, wait) {
    var lastTime,
        timer;

    return function() {
        var now = Date.now(),
            context = this,
            args = arguments;

        if (lastTime && now < lastTime + wait) {
            clearTimeout(timer);

            timer = setTimeout(function() {
                lastTime = now;
                func.apply(context, args);
            }, wait);
        } else {
            lastTime = now;
            func.apply(context, args);
        }
    };
}

export function Common__objectExtend(dst, src, deep) {
    Common__objectEach(src, function(key, value) {
        if (deep && Common__isPlainObject(value)) {
            if (!Common__isPlainObject(dst[key])) {
                dst[key] = {};
            }

            Common__objectExtend(dst[key], value, deep);
        } else if (deep && value instanceof Array) {
            if (!(dst[key] instanceof Array)) {
                dst[key] = [];
            }

            Common__objectExtend(dst[key], value, deep);
        } else if (value !== undefined) {
            dst[key] = value;
        }
    });

    return dst;
}

export function Common__objectEach(obj, callback) {
    var key,
        hasOwn = Object.prototype.hasOwnProperty;

    for (key in obj) {
        if (hasOwn.call(obj, key)) {
            callback(key, obj[key]);
        }
    }
}

export function Common__isPlainObject(obj) {
    return obj instanceof Object && obj != obj.window && Object.getPrototypeOf(obj) == Object.prototype;
}

